// safe-html.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(value?: string): SafeHtml {
        if (!value) return '';

        // إضافة !important لكل style inline
        const htmlWithImportant = value.replace(/style="(.*?)"/g, (_match, p1) => {
            // لكل style، ضيف !important لكل خاصية لو مش موجود
            const importantStyles = p1
                .split(';')
                .map((s: any) => s.trim())
                .filter((s: any) => s.length > 0)
                .map((s: any) => s.endsWith('!important') ? s : `${s} !important`)
                .join('; ');
            return `style="${importantStyles}"`;
        });

        return this.sanitizer.bypassSecurityTrustHtml(htmlWithImportant);
    }
}